var GoodsWarranty;

GoodsWarranty = window.GoodsWarranty != null ? window.GoodsWarranty : window.GoodsWarranty = {};

if (GoodsWarranty.View == null) {
  GoodsWarranty.View = require('./views/goods_warranty');
}

GoodsWarranty.init = function(arg, done) {
  var buyButton, goodsWarranty;
  buyButton = arg.buyButton, goodsWarranty = arg.goodsWarranty;
  if (goodsWarranty == null) {
    return done();
  }
  return $(function() {
    new GoodsWarranty.View({
      buyButton: buyButton,
      goodsWarranty: goodsWarranty
    });
    return done();
  });
};

module.exports = GoodsWarranty;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9nb29kc193YXJyYW50eS9mcm9udGVuZC9pbmRleC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2dvb2RzX3dhcnJhbnR5L2Zyb250ZW5kL2luZGV4LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGFBQUEsa0NBQWdCLE1BQU0sQ0FBQyxnQkFBUCxNQUFNLENBQUMsZ0JBQWlCOzs7RUFDeEMsYUFBYSxDQUFDLE9BQVEsT0FBQSxDQUFRLHdCQUFSOzs7QUFFdEIsYUFBYSxDQUFDLElBQWQsR0FBcUIsU0FBQyxHQUFELEVBQTZCLElBQTdCO0FBQ25CLE1BQUE7RUFEcUIsMkJBQVc7RUFDaEMsSUFBcUIscUJBQXJCO0FBQUEsV0FBTyxJQUFBLENBQUEsRUFBUDs7U0FFQSxDQUFBLENBQUUsU0FBQTtJQUNBLElBQUksYUFBYSxDQUFDLElBQWxCLENBQXVCO01BQUMsV0FBQSxTQUFEO01BQVksZUFBQSxhQUFaO0tBQXZCO1dBQ0EsSUFBQSxDQUFBO0VBRkEsQ0FBRjtBQUhtQjs7QUFPckIsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
